// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20A-0","newExpiryDate":"styles_newExpiryDate__3kYBf","footer":"styles_footer__3BBPi"};